import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import { AchInfo } from './ach-info/desktop/ach-info';
import { AchInfoFormState } from './ach-info/ach-info';

interface Props {
    data?: AchInfoFormState;
    amount?: number;
    isInvoicePayment: boolean;
    redirectToPayPage?: () => void;
    isEmbedded?: boolean;
}

@observer
export class AchInfoContainer extends React.Component<Props> {
    @observable data!: AchInfoFormState;

    constructor(props: Props) {
        super(props);
        this.data = this.props.data || new AchInfoFormState();
    }

    render() {
        return this.data ? (
            <AchInfo
                container={this}
                amount={this.props.amount || 0}
                redirectToPayPage={this.props.redirectToPayPage}
                isInvoicePayment={this.props.isInvoicePayment}
                isEmbedded={this.props.isEmbedded || false}
            />
        ) : null;
    }
}
